import { defineMessages } from "react-intl";

import {
	hasPreviousOtherOrganTransplantationMessages,
	previousOtherOrganTransplantationTypeMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/clinical-data/pre-immunisation/previousOtherOrganTransplantation";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	previousOtherOrganTransplantation: {
		id: "ktx.form.previous_other_organ_transplantation.title",
		defaultMessage: "Korábbi szerv- vagy szövet transzplantáció"
	},
	transplantations: {
		id: "ktx.form.previous_other_organ_transplantation.value",
		defaultMessage: "Transzplantációk"
	},
	hasPreviousOtherOrganTransplantation: {
		id: "ktx.form.previous_other_organ_transplantation.hasPreviousOtherOrganTransplantation",
		defaultMessage: "Transzplantációk?"
	},
	other: {
		id: "ktx.form.previous_other_organ_transplantation.other",
		defaultMessage: "Egyéb transzplantáció"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["hasPreviousOtherOrganTransplantation"],
						label: messages.hasPreviousOtherOrganTransplantation,
						errorMessages: genericErrorMessages,
						input: {
							type: "button-group",
							props: {
								labels: hasPreviousOtherOrganTransplantationMessages
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: [
							"previousOtherOrganTransplantations",
							"previousOtherOrganTransplantationType"
						],
						label: messages.transplantations,
						errorMessages: genericErrorMessages,
						input: {
							type: "checkbox-group",
							props: {
								labels: previousOtherOrganTransplantationTypeMessages,
								direction: "vertical",
								columns: 2
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: [
							"previousOtherOrganTransplantations",
							"previousOtherOrganTransplantationTypeOther"
						],
						label: messages.other,
						errorMessages: genericErrorMessages,
						input: {
							type: "textarea",
							props: {}
						}
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_previousOtherOrganTransplantation",
	value: {
		schemaId: "previousOtherOrganTransplantation",
		title: messages.previousOtherOrganTransplantation,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
